"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyDashboardModalVisibleState = void 0;
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const react_i18next_1 = require("react-i18next");
const dashboard_1 = require("../../../server/models/dashboard");
const EmbedReportPage_1 = require("../EmbeddedReports/EmbedReportPage");
const folder_1 = require("../../../server/models/folder");
const SaveInFolderModal_1 = __importDefault(require("./SaveInFolderModal"));
exports.copyDashboardModalVisibleState = (0, recoil_1.atom)({
    key: 'copyDashboardModalVisibleState',
    default: false,
});
const CopyDashboardModal = ({ dashboardId, defaultFolderId, t, }) => {
    const internalFilters = (0, recoil_1.useRecoilValue)(EmbedReportPage_1.embedInternalFilterState);
    const [visible, setVisible] = (0, recoil_1.useRecoilState)(exports.copyDashboardModalVisibleState);
    const saveInFolderModalProps = {
        defaultFolderId: defaultFolderId,
        formSubmitCallback: async (title, folderId) => await (0, dashboard_1.saveDashboardAs)(title, String(folderId), dashboardId, internalFilters),
        successMessage: t('dashboardSaveSuccess'),
        failureMessage: t('dashboardSaveFail'),
        errorMessage: t('dashboardSaveError'),
        titleName: 'saveAsDashboardTitle',
        titleValidationCallback: async (title, folderId) => await (0, folder_1.verifyDashboardNameUniqueIn)(title, folderId.toString()),
        notificationMessage: t('dashboardSaveNotify'),
        placeholder: t('dashboardSavePlaceholder'),
        duplicateErrorMessage: t('dashboardSaveDuplicate'),
        autoFocus: true,
        headerText: t('dashboardDuplicateHeader'),
        primaryButtonText: t('dashboardSaveButton'),
        visible: visible,
        setVisible: (isVisible) => setVisible(isVisible),
        t: t,
    };
    return react_1.default.createElement(SaveInFolderModal_1.default, { ...saveInFolderModalProps });
};
exports.default = (0, react_i18next_1.withTranslation)('ModalWindow')(CopyDashboardModal);
